import React, {memo, useEffect, useState} from 'react';
import './style.css';
import {useInputWithFocus} from 'common/hook/useInputWithFocus';
import {Select, Spin} from 'antd';
import {optionsResponseType} from 'components/form/options/options';
import {ReactComponent as SelectArrayIcon} from '../../../../../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../../../../../../assets/i/arrow-up-icon.svg';
import {ReactComponent as FileIcon} from '../../../../../../../../../assets/main/groups/form/file.svg';
import {ReactComponent as CloseIcon} from '../../../../../../../../../assets/header/сlose.svg';
import {ReactComponent as InfoSmallerIcon} from '../../../../../../../../../assets/main/test/info-smaller.svg';
import {useFileUpload} from "common/hook/use-file-upload";
import {useAppDispatch, useAppSelector} from "common/hook";
import {
    setTextTabData, TestItem
} from "features/model/slice/create-test/create-test-form/createTestForm";
import {FieldsRow} from "../../../../test-edit-item/test-descr-box/block-tabs/general/fields-row/FieldsRow";
import {useParams} from "react-router-dom";
import {addFile} from "features/model/service/test/file/add-file/addFile";
import {deleteFile} from "features/model/service/test/file/delete-file/deleteFile";
import TextArea from "antd/es/input/TextArea";
import {resetDeleteFile} from "features/model/slice/test/delete-file/deleteFileSlice";
import {resetAddFile, setErrorsFile} from "features/model/slice/lessons/response-add-file/responseAddFile";
import {TestImage} from "../../../../../../students-test/separate-test/separate-test-table/test-tabs/test-table/test-image/Test-image";

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

interface IImageTab {
    questionData?: TestItem;
}

export const ImageTab = memo(({questionData}: IImageTab) => {
    const dispatch = useAppDispatch();
    const [open, setOpen] = useState<boolean>(false);
    const [localError, setLocalError] = useState('');
    const filePatch = useAppSelector(state => state.responseAddFile);
    const {file, fileName, questionId, error} = filePatch;
    const setDeleteFileSuccess = useAppSelector(state => state.deleteFile.success);
    const setDeleteFileQuestionId = useAppSelector(state => state.deleteFile.questionId);

    const [values, setValues] = useState<TestItem>(questionData as TestItem || {});

    useEffect(() => {
        if (questionData) {
            setValues({
                ...questionData,
                tabType: 'imageType',
            });
        }
    }, [questionData?.id, questionData?.tabType, questionData?.file?.path, questionData?.file?.fileName]);

    const {testId} = useParams();

    const OnClickHandler = () => {
        setOpen(!open);
    };

    const onClickDeleteFile = (path: string) => {
        dispatch(deleteFile({testId, filePath: path, questionId: questionData?.id ?? ''}));
        handleFileRemove1(0);
        setLocalError('');
    };

    const {
        isFilled,
        handleFocus,
        handleBlur
    } = useInputWithFocus([false, false, false, false, false, false, false, false, false]);

    const fetchFiles = async (files: File[]) => {
        try {
            await dispatch(addFile({file: files, testId, questionId: questionData?.id ?? ''}));
        } catch (err) {
            console.error('Произошла ошибка при отправке файлов:', err);
        }
    };

    const {
        drag: drag1,
        fileNames: fileNames1,
        fileInputRef: fileInputRef1,
        handleFileUpload: handleFileUpload1,
        handleFileRemove: handleFileRemove1,
        handleFileChange: handleFileChange1,
        dragStartHandler: dragStartHandler1,
        dragLeaveHandler: dragLeaveHandler1,
        onDropHandler: onDropHandler1,
        uploadedFiles: uploadedFiles1,
        setFileNames,
        setUploadedFiles
    } = useFileUpload();

    const validateAndUpload = (files: File[]) => {
        if (!files.length) {
            return;
        }
        const imageFile = files[files.length - 1];
        if (!ALLOWED_IMAGE_TYPES.includes(imageFile.type)) {
            setLocalError('Допустимы только изображения JPG, PNG, GIF или WEBP.');
            setFileNames([]);
            setUploadedFiles([]);
            return;
        }
        setLocalError('');
        fetchFiles([imageFile]);
    };

    useEffect(() => {
        if (uploadedFiles1.length > 0) {
            validateAndUpload(uploadedFiles1);
        }
    }, [uploadedFiles1]);

    useEffect(() => {
        if (error) {
            setFileNames([]);
            setUploadedFiles([]);
        } else if (!error && fileNames1.length > 1) {
            dispatch(setErrorsFile({success: false, error: '', errors: {}}));
        }
    }, [error, fileNames1.length]);

    useEffect(() => {
        if (filePatch.success && questionId === questionData?.id) {
            setValues((prevValues) => ({
                ...prevValues,
                tabType: 'imageType',
                file: {
                    path: file,
                    fileName: fileName,
                },
            }));
            dispatch(resetAddFile());
        }
    }, [filePatch.success, file, fileName, questionId, questionData?.id]);

    useEffect(() => {
        if (setDeleteFileSuccess && setDeleteFileQuestionId === questionData?.id) {
            setValues((prevValues) => ({
                ...prevValues,
                file: {
                    path: '',
                    fileName: '',
                },
            }));
            dispatch(resetDeleteFile());
        }
    }, [setDeleteFileSuccess, setDeleteFileQuestionId, questionData?.id]);

    useEffect(() => {
        dispatch(setTextTabData({
            ...values,
            tabType: 'imageType',
        }));
    }, [values, dispatch]);

    const handleChange = (name: string, value: string) => {
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const hasUploadedFile = Boolean(values.file?.path);
    const uploadDisabled = hasUploadedFile || fileNames1.length === 1;
    const fileInputId = `test-question-image-${questionData?.id}`;

    return (
        <>
            <div className="fields-row two-cols">
                <div className="field middle-w">
                    <div className="course-type" onClick={OnClickHandler}>
                        <span className={values.questionType ? 'active-label' : ''}>Тип ответа</span>
                        <Select
                            style={{width: '100%'}}
                            value={values.questionType}
                            className="custom-select select-new"
                            onChange={(value) => handleChange('questionType', value.toString())}
                            options={optionsResponseType}
                            onFocus={() => handleFocus(0)}
                            onBlur={handleBlur}
                            suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                        />
                    </div>
                </div>

                <div className="field large-w">
                    <div style={{width: '100%'}} className={`field ${isFilled[0] ? 'filled' : ''}`}>
                        <label className={`field-name ${values.questionTitle ? 'active-label' : ''}`}>
                            Текст вопроса
                        </label>
                        <div className="ant-select-selector">
                            <TextArea
                                name="questionTitle"
                                className="form-control  form-control-new"
                                value={values.questionTitle}
                                onChange={(event) => handleChange('questionTitle', event.target.value)}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                                autoSize={{minRows: 1, maxRows: 10}}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="fields-row">
                <div className="field">
                    {drag1 ?
                        <div
                            onDragStart={(e) => dragStartHandler1(e)}
                            onDragLeave={(e) => dragLeaveHandler1(e)}
                            onDragOver={(e) => dragStartHandler1(e)}
                            onDrop={(e) => onDropHandler1(e)}
                            onClick={handleFileUpload1}
                            className="upload-box upload-box-drop"
                        >
                            <p>Перетащите изображение сюда или</p>
                        </div> :
                        <div className={uploadDisabled ? 'upload-box file-disabled' : 'upload-box'}>
                            <div
                                onDragStart={(e) => dragStartHandler1(e)}
                                onDragLeave={(e) => dragLeaveHandler1(e)}
                                onDragOver={(e) => dragStartHandler1(e)}
                                onDrop={(e) => onDropHandler1(e)}
                                className="form-button"
                                onClick={handleFileUpload1}
                            >
                                <FileIcon/>
                                <p
                                    onDragStart={(e) => dragStartHandler1(e)}
                                    onDragLeave={(e) => dragLeaveHandler1(e)}
                                    onDragOver={(e) => dragStartHandler1(e)}
                                    onDrop={(e) => onDropHandler1(e)}
                                >
                                    Перетащите изображение сюда или <a>выберите файл</a>
                                </p>
                            </div>

                            <input
                                id={fileInputId}
                                type="file"
                                name="files"
                                accept="image/jpeg,image/png,image/gif,image/webp"
                                ref={fileInputRef1}
                                style={{display: "none"}}
                                onChange={handleFileChange1}
                                disabled={uploadDisabled}
                            />
                        </div>
                    }

                    <div className="uploaded-files">
                        {hasUploadedFile ? (
                            <>
                                <span
                                    className="js-remove-file image-remove-file"
                                    onClick={() => onClickDeleteFile(values.file?.path || '')}
                                >
                                    <CloseIcon/>
                                </span>
                                <TestImage
                                    imageUrl={values.file?.path}
                                    teacherPreview={true}
                                />
                            </>
                        ) : (
                            <ul className="uploaded-files-list">
                                {fileNames1 && fileNames1.map((uploadFileName, index) => (
                                    <li key={index}>
                                        <span className="js-remove-file"
                                              onClick={() => handleFileRemove1(index)}>
                                            <CloseIcon/>
                                        </span>
                                        <div className="file-name">
                                            <span>{questionData?.file?.fileName || uploadFileName}</span>
                                            <span style={{paddingLeft: '10px'}}><Spin size="small"/></span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                        {(localError || error) && <p className="field-error">{localError || error}</p>}
                    </div>

                </div>
            </div>
            {values.questionType === 'determineProcedure' &&
                <p className="p-icon info-icon">
                    Сначала введите правильный порядок слов или фраз, а затем перемешайте последовательность.
                    <span className="icon">
                        <InfoSmallerIcon/>
                </span>
                </p>
            }
            <FieldsRow values={values}/>
        </>
    );
});
